import React from "react";
import HomeCard from "./HomeCard";
import {Col, Row} from "antd";
import {HOME_CONTAINER_CORE_LIST} from "../constants";

const gutters: Record<PropertyKey, number> = {};
const vgutters: Record<PropertyKey, number> = {};
const colCounts: Record<PropertyKey, number> = {};

[8, 16, 24, 32, 40, 48].forEach((value, i) => {
    gutters[i] = value;
});
[8, 16, 24, 32, 40, 48].forEach((value, i) => {
    vgutters[i] = value;
});
[2, 3, 4, 6, 8, 12].forEach((value, i) => {
    colCounts[i] = value;
});

const HomeContainer: React.FC = () => {
    return (
        <div className={'container'}>
            <div className={'title-container'}>
                <div className={'title'}>— 核心服务 —</div>
                <div className={'sub-title'}>CORE SERVICE</div>
            </div>
            <div className={'core-card-container'}>
                <Row gutter={[gutters[2], vgutters[2]]}>
                    {HOME_CONTAINER_CORE_LIST.map((v, i) => {
                        return (
                            <Col xs={24} sm={24} md={8} lg={8} xl={8} key={`core-card-container-${i}`}>
                                <HomeCard
                                    title={v?.title}
                                    subTitle={v?.subTitle}
                                    link={v?.link}
                                    imageUrl={v?.imageUrl}
                                    imageBgType={v?.imageBgType}
                                />
                            </Col>
                        )
                    })}
                </Row>
            </div>
        </div>
    )
}

export default React.memo(HomeContainer)